document.addEventListener("DOMContentLoaded", function () {
  const triggers = document.querySelectorAll(".interactive-info__popup-trigger");

  function closeAllPopups() {
    document.querySelectorAll(".interactive-info__popup.active").forEach((p) => {
      p.classList.remove("active");
    });
    document.body.style.overflow = "";
  }

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", function (e) {
      e.stopPropagation();

      const image = this.closest(".interactive-info__image");
      const popup = image.querySelector(".interactive-info__popup");

      if (!popup) return;

      const wasActive = popup.classList.contains("active");

      closeAllPopups();

      if (!wasActive) {
        popup.classList.add("active");

        if (window.innerWidth <= 900) {
          document.body.style.overflow = "hidden";
        }
      }
    });
  });

  document.addEventListener("click", function (e) {
    if (!e.target.closest(".interactive-info__popup") && !e.target.closest(".interactive-info__popup-trigger")) {
      closeAllPopups();
    }
  });

  const popupClosers = document.querySelectorAll(".interactive-info__popup-closer");

  popupClosers.forEach((closer) => {
    closer.addEventListener("click", () => {
      closeAllPopups();
    });
  });
});
